<div class="carousel-slide">
  <ng-container #carouselItem></ng-container>
</div>
